export class GradeStatementOptionMessageType {
    readonly FutureStudentWorkComplete: string = 'FutureStudentWorkComplete';
    readonly FutureIncompleteGradeError: string = 'FutureIncompleteGradeError';
    readonly PastStudentWorkComplete: string = 'PastStudentWorkComplete';
    readonly PastStudentWorkNotComplete: string = 'PastStudentWorkNotComplete';
    readonly PastIncompleteGradeError: string = 'PastIncompleteGradeError';
    readonly PastStudentWorkCompleteAfterExtension: string = 'PastStudentWorkCompleteAfterExtension';

    static getInstance(): GradeStatementOptionMessageType {
        return new GradeStatementOptionMessageType();
    }
}
